export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  status: '连载中' | '已完结';
  chapters: number;
  rating: string;
  views: string;
  tags: string[];
  description: string;
  cover: string;
  isFeatured?: boolean;
  isNew?: boolean;
}

export const categories: { name: string; icon: string; desc: string; count: string }[] = [
  { name: '热血', icon: 'ri-fire-fill', desc: '燃到沸腾的战斗与友情', count: '2,418部' },
  { name: '恋爱', icon: 'ri-heart-3-fill', desc: '心动日常与甜蜜故事', count: '3,026部' },
  { name: '玄幻', icon: 'ri-moon-clear-fill', desc: '东方玄幻与异世界冒险', count: '1,874部' },
  { name: '悬疑', icon: 'ri-focus-3-fill', desc: '烧脑推理与暗黑谜团', count: '1,206部' },
  { name: '搞笑', icon: 'ri-emotion-laugh-fill', desc: '轻松解压的爆笑日常', count: '2,311部' },
  { name: '科幻', icon: 'ri-rocket-2-fill', desc: '未来世界与星际探索', count: '1,158部' },
  { name: '校园', icon: 'ri-graduation-cap-fill', desc: '青春成长的那些事', count: '1,593部' },
  { name: '都市', icon: 'ri-building-2-fill', desc: '现代都市的生活百态', count: '1,769部' },
  { name: '动作', icon: 'ri-sword-fill', desc: '拳拳到肉的动作场面', count: '1,447部' },
  { name: '冒险', icon: 'ri-compass-3-fill', desc: '未知世界的探索之旅', count: '1,335部' },
];

export const comics: Comic[] = [
  {
    id: 'c1',
    title: '星海征途',
    author: '北岛绘',
    category: '科幻',
    status: '连载中',
    chapters: 236,
    rating: '9.6',
    views: '1.28亿',
    tags: ['星际', '冒险', '热血'],
    description: '少年陆遥意外觉醒星核之力，踏上横跨银河的征途，在广袤宇宙中寻找失落的文明与自己的身世之谜。',
    cover: 'https://readdy.ai/api/search-image?query=A%20hand-drawn%20manga%20cover%20illustration%20of%20a%20young%20hero%20standing%20before%20a%20glowing%20space%20portal%20with%20starships%20and%20nebula%20in%20orange%20and%20teal%20tones%2C%20dynamic%20composition%2C%20clean%20linework%2C%20vibrant%20warm%20palette%2C%20cinematic%20lighting%2C%20editorial%20style&width=600&height=900&seq=cover-star-sea&orientation=portrait',
    isFeatured: true,
    isNew: true,
  },
  {
    id: 'c2',
    title: '长安少年行',
    author: '青梧',
    category: '玄幻',
    status: '已完结',
    chapters: 318,
    rating: '9.4',
    views: '1.95亿',
    tags: ['古风', '修仙', '成长'],
    description: '盛世长安，一位无名少年误入仙门，在纷争与阴谋中一步步踏上登仙之路，守护他珍视的故土与故人。',
    cover: 'https://readdy.ai/api/search-image?query=A%20hand-drawn%20manga%20cover%20illustration%20of%20a%20young%20cultivator%20in%20ancient%20chinese%20robes%20with%20a%20glowing%20sword%20against%20a%20warm%20golden%20ancient%20city%20skyline%20at%20dusk%2C%20dynamic%20composition%2C%20clean%20linework%2C%20vibrant%20warm%20palette%2C%20cinematic%20lighting&width=600&height=900&seq=cover-changan&orientation=portrait',
    isFeatured: true,
  },
  {
    id: 'c3',
    title: '迷雾侦探社',
    author: '墨鱼丸',
    category: '悬疑',
    status: '连载中',
    chapters: 154,
    rating: '9.5',
    views: '8,460万',
    tags: ['推理', '都市', '暗黑'],
    description: '三流侦探与神秘少女组成搭档，在层层迷雾中揭开一桩桩诡异案件背后的真相，却意外卷入更大的阴谋。',
    cover: 'https://readdy.ai/api/search-image?query=A%20hand-drawn%20manga%20cover%20illustration%20of%20a%20detective%20in%20a%20trench%20coat%20holding%20a%20magnifying%20glass%20under%20dim%20warm%20streetlight%20in%20a%20foggy%20alley%2C%20mysterious%20atmosphere%2C%20clean%20linework%2C%20warm%20amber%20and%20coral%20palette%2C%20cinematic%20lighting&width=600&height=900&seq=cover-mist-detective&orientation=portrait',
    isFeatured: true,
    isNew: true,
  },
  {
    id: 'c4',
    title: '心动便利店',
    author: '小甜瓜',
    category: '恋爱',
    status: '连载中',
    chapters: 98,
    rating: '9.3',
    views: '6,210万',
    tags: ['都市', '日常', '甜宠'],
    description: '便利店夜班店员与常客之间的青涩悸动，每一个深夜都藏着一份偷偷靠近的心跳与温暖。',
    cover: 'https://readdy.ai/api/search-image?query=A%20hand-drawn%20manga%20cover%20illustration%20of%20two%20young%20people%20smiling%20near%20a%20cozy%20glowing%20night%20convenience%20store%20with%20warm%20orange%20neon%20light%2C%20romantic%20sweet%20mood%2C%20clean%20linework%2C%20vibrant%20warm%20palette%2C%20soft%20cinematic%20lighting&width=600&height=900&seq=cover-convenience&orientation=portrait',
    isNew: true,
  },
  {
    id: 'c5',
    title: '爆笑同桌',
    author: '阿柴',
    category: '搞笑',
    status: '连载中',
    chapters: 172,
    rating: '9.2',
    views: '5,780万',
    tags: ['校园', '日常', '沙雕'],
    description: '一对欢喜冤家同桌的爆笑日常，从互相嫌弃到默契十足，笑料百出的青春校园故事。',
    cover: 'https://readdy.ai/api/search-image?query=A%20hand-drawn%20manga%20cover%20illustration%20of%20two%20playful%20school%20deskmates%20laughing%20at%20desks%20with%20colorful%20school%20supplies%20flying%20around%2C%20comic%20energetic%20mood%2C%20clean%20linework%2C%20warm%20vibrant%20palette%2C%20playful%20lighting&width=600&height=900&seq=cover-desk-mate&orientation=portrait',
    isNew: true,
  },
  {
    id: 'c6',
    title: '苍穹剑魂',
    author: '云深',
    category: '玄幻',
    status: '已完结',
    chapters: 402,
    rating: '9.7',
    views: '2.36亿',
    tags: ['剑修', '热血', '仙侠'],
    description: '剑道天才跌落凡尘，重历修行路，以手中之剑斩破苍穹，问鼎剑道巅峰。经典仙侠热血长篇。',
    cover: 'https://readdy.ai/api/search-image?query=A%20hand-drawn%20manga%20cover%20illustration%20of%20a%20mighty%20swordsman%20unleashing%20a%20golden%20energy%20sword%20into%20the%20sky%20among%20clouds%20and%20peaks%2C%20epic%20warm%20golden%20and%20coral%20tones%2C%20clean%20linework%2C%20dynamic%20composition%2C%20cinematic%20lighting&width=600&height=900&seq=cover-sword-soul&orientation=portrait',
  },
  {
    id: 'c7',
    title: '都市异闻录',
    author: '夜归人',
    category: '都市',
    status: '已完结',
    chapters: 268,
    rating: '9.1',
    views: '9,870万',
    tags: ['灵异', '单元剧', '悬疑'],
    description: '都市霓虹之下藏着无数诡异传闻，普通上班族在机缘巧合下卷入离奇事件，逐步揭开都市背后的神秘面纱。',
    cover: 'https://readdy.ai/api/search-image?query=A%20hand-drawn%20manga%20cover%20illustration%20of%20a%20silhouetted%20city%20skyline%20at%20night%20with%20mysterious%20glowing%20ghostly%20figures%20and%20fog%2C%20moody%20atmosphere%2C%20warm%20amber%20and%20deep%20brown%20palette%2C%20clean%20linework%2C%20cinematic%20lighting&width=600&height=900&seq=cover-urban-mystery&orientation=portrait',
  },
  {
    id: 'c8',
    title: '萌宠大作战',
    author: '胖达',
    category: '搞笑',
    status: '已完结',
    chapters: 156,
    rating: '9.0',
    views: '7,140万',
    tags: ['萌宠', '治愈', '日常'],
    description: '一群性格各异的萌宠在小小的公寓里闹出无数笑话，治愈又暖心的陪伴日常。',
    cover: 'https://readdy.ai/api/search-image?query=A%20hand-drawn%20manga%20cover%20illustration%20of%20adorable%20kitten%20and%20puppy%20with%20big%20eyes%20surrounded%20by%20cute%20accessories%20in%20a%20warm%20cozy%20room%2C%20kawaii%20chibi%20style%2C%20soft%20warm%20orange%20palette%2C%20clean%20linework%2C%20playful%20lighting&width=600&height=900&seq=cover-pets&orientation=portrait',
  },
  {
    id: 'c9',
    title: '月下海棠',
    author: '沉香',
    category: '恋爱',
    status: '已完结',
    chapters: 142,
    rating: '9.3',
    views: '6,830万',
    tags: ['古风', '虐恋', '宫廷'],
    description: '深宫之中，一场跨越身份的爱恋在月下悄然绽放，海棠花开时，故人归来否。',
    cover: 'https://readdy.ai/api/search-image?query=A%20hand-drawn%20manga%20cover%20illustration%20of%20an%20elegant%20ancient%20chinese%20woman%20under%20a%20blooming%20haitang%20tree%20in%20moonlight%2C%20romantic%20melancholy%20mood%2C%20warm%20coral%20and%20gold%20palette%2C%20clean%20linework%2C%20soft%20cinematic%20lighting&width=600&height=900&seq=cover-moon-haitang&orientation=portrait',
  },
  {
    id: 'c10',
    title: '极限特工',
    author: '冷锋',
    category: '动作',
    status: '连载中',
    chapters: 118,
    rating: '9.2',
    views: '7,620万',
    tags: ['特工', '战斗', '都市'],
    description: '退隐特工重出江湖，凭借一身格斗技巧与过人胆识，在危机四伏的都市中完成任务，守护所爱之人。',
    cover: 'https://readdy.ai/api/search-image?query=A%20hand-drawn%20manga%20cover%20illustration%20of%20a%20sleek%20special%20agent%20in%20tactical%20gear%20mid-action%20with%20explosive%20warm%20orange%20motion%20lines%20behind%2C%20dynamic%20composition%2C%20clean%20linework%2C%20high%20contrast%20warm%20palette%2C%20cinematic%20lighting&width=600&height=900&seq=cover-special-agent&orientation=portrait',
    isNew: true,
  },
  {
    id: 'c11',
    title: '银河补习班',
    author: '鹿鸣',
    category: '科幻',
    status: '已完结',
    chapters: 204,
    rating: '9.1',
    views: '5,540万',
    tags: ['星际', '校园', '青春'],
    description: '一所建在陨石带上的奇怪补习班，一群来自不同星球的少年少女，在嬉笑打闹中共同成长。',
    cover: 'https://readdy.ai/api/search-image?query=A%20hand-drawn%20manga%20cover%20illustration%20of%20a%20group%20of%20teenagers%20with%20spacesuits%20and%20books%20outside%20a%20space%20academy%20dome%2C%20fun%20youthful%20mood%2C%20warm%20teal%20and%20orange%20palette%2C%20clean%20linework%2C%20playful%20cinematic%20lighting&width=600&height=900&seq=cover-galaxy-school&orientation=portrait',
  },
  {
    id: 'c12',
    title: '暗夜裁决',
    author: '黑曜',
    category: '悬疑',
    status: '连载中',
    chapters: 96,
    rating: '9.4',
    views: '5,090万',
    tags: ['悬疑', '动作', '复仇'],
    description: '黑暗中有人替天行道，正义与私刑的边界逐渐模糊，一场关于裁决的博弈就此展开。',
    cover: 'https://readdy.ai/api/search-image?query=A%20hand-drawn%20manga%20cover%20illustration%20of%20a%20hooded%20figure%20in%20shadow%20under%20a%20single%20warm%20red%20spotlight%20with%20a%20burning%20gavel%20and%20fog%2C%20mysterious%20tense%20mood%2C%20dark%20warm%20coral%20palette%2C%20clean%20linework%2C%20cinematic%20lighting&width=600&height=900&seq=cover-dark-verdict&orientation=portrait',
    isNew: true,
  },
  {
    id: 'c13',
    title: '桃色季节',
    author: '绵绵',
    category: '恋爱',
    status: '连载中',
    chapters: 84,
    rating: '9.0',
    views: '4,370万',
    tags: ['校园', '初恋', '日常'],
    description: '高一那年春天，樱花与初恋一同降临，青涩懵懂的校园恋爱在四季更迭中慢慢生长。',
    cover: 'https://readdy.ai/api/search-image?query=A%20hand-drawn%20manga%20cover%20illustration%20of%20a%20schoolgirl%20and%20schoolboy%20under%20falling%20pink%20petals%20on%20a%20school%20path%20at%20spring%2C%20sweet%20youthful%20romance%20mood%2C%20warm%20coral%20and%20cream%20palette%2C%20clean%20linework%2C%20soft%20cinematic%20lighting&width=600&height=900&seq=cover-peach-season&orientation=portrait',
    isNew: true,
  },
  {
    id: 'c14',
    title: '龙窟探险队',
    author: '拓荒者',
    category: '冒险',
    status: '已完结',
    chapters: 226,
    rating: '9.2',
    views: '8,120万',
    tags: ['冒险', '热血', '秘境'],
    description: '一支无名探险队在未知秘境中寻找传说龙窟，闯过重重机关与凶兽，揭开上古遗迹的秘密。',
    cover: 'https://readdy.ai/api/search-image?query=A%20hand-drawn%20manga%20cover%20illustration%20of%20explorers%20with%20torches%20inside%20a%20massive%20glowing%20dragon%20cave%20with%20treasure%20and%20ancient%20runes%2C%20epic%20adventure%20mood%2C%20warm%20amber%20and%20coral%20palette%2C%20clean%20linework%2C%20cinematic%20lighting&width=600&height=900&seq=cover-dragon-cave&orientation=portrait',
  },
  {
    id: 'c15',
    title: '机械之心',
    author: '齿轮',
    category: '科幻',
    status: '已完结',
    chapters: 186,
    rating: '9.3',
    views: '6,950万',
    tags: ['赛博朋克', '机甲', '热血'],
    description: '近未来都市中，人类与机械意识纠缠，一位觉醒机械之心的少年踏上寻找自我与真相的旅程。',
    cover: 'https://readdy.ai/api/search-image?query=A%20hand-drawn%20manga%20cover%20illustration%20of%20a%20half-human%20half-mech%20young%20hero%20with%20glowing%20core%20against%20a%20cyberpunk%20city%20in%20warm%20orange%20and%20gold%20tones%2C%20clean%20linework%2C%20dynamic%20composition%2C%20cinematic%20lighting&width=600&height=900&seq=cover-mech-heart&orientation=portrait',
  },
  {
    id: 'c16',
    title: '吃货小当家',
    author: '糯米团',
    category: '搞笑',
    status: '连载中',
    chapters: 142,
    rating: '9.1',
    views: '5,360万',
    tags: ['美食', '日常', '治愈'],
    description: '立志尝遍天下美食的元气少女，与一群吃货朋友在街头巷尾开启奇妙的美食冒险之旅。',
    cover: 'https://readdy.ai/api/search-image?query=A%20hand-drawn%20manga%20cover%20illustration%20of%20a%20cheerful%20energetic%20girl%20holding%20a%20giant%20steaming%20dumpling%20with%20delicious%20food%20floating%20around%2C%20warm%20appetizing%20mood%2C%20warm%20coral%20and%20gold%20palette%2C%20clean%20linework%2C%20playful%20lighting&width=600&height=900&seq=cover-foodie&orientation=portrait',
    isNew: true,
  },
];

export const faqs: { q: string; a: string }[] = [
  {
    q: '4399漫画网提供哪些漫画分类？',
    a: '4399漫画网提供热血、恋爱、玄幻、悬疑、搞笑、科幻、校园、都市、动作、冒险等全品类分类浏览。你可以通过顶部分类入口快速筛选，找到符合口味的作品，同时支持关键词搜索与热门排行辅助查找。',
  },
  {
    q: '如何快速查找已经完结的漫画？',
    a: '进入"完结作品库"板块即可浏览全部已完结作品，这里收录了诸如《长安少年行》《苍穹剑魂》等经典长篇，支持按热度、评分与更新时间排序，方便你一次看个痛快。',
  },
  {
    q: '新上架作品多久更新一次？',
    a: '新上架板块会实时收录平台最新上线的漫画，包括连载新作与完结新库，通常在作者更新后第一时间同步，建议搭配站内搜索与分类筛选使用，第一时间发现新鲜好故事。',
  },
  {
    q: '能否只看自己感兴趣的特定类型？',
    a: '可以。你可以通过分类浏览进入对应类型，也可以使用搜索功能直接输入作品名或作者进行精准定位，再结合热门排行与评分信息，快速从海量漫画中锁定想看的作品。',
  },
  {
    q: '4399漫画网的搜索功能如何使用？',
    a: '在页面顶部的搜索框中输入作品名、作者或关键词并确认，即可获得匹配结果。搜索支持按分类、连载状态等维度进一步筛选，帮助你高效、精准地找到目标漫画。',
  },
];

export const hotList = [...comics]
  .map((c) => c)
  .sort((a, b) => parseFloat(b.rating) - parseFloat(a.rating))
  .slice(0, 8);

export const completedList = comics.filter((c) => c.status === '已完结');
export const newList = comics.filter((c) => c.isNew);
export const featuredList = comics.filter((c) => c.isFeatured);